// KoachLayoutContainer: toggles koach header/menu visibility by route.
import React from "react";
import KoachLayoutComponent from "./KoachLayout";
import { useLocation } from "react-router-dom";

const STANDALONE_MAIN_PATH = [
    "/koach/my",
    "/koach/follow",
    "/koach/wannabe",
    "/koach/casting/message/",
    "/koach/block",
];
const NO_MENU_PATH = [
    "/koach/my/notice/",
    "/koach/alarm",
    // 코치 콘텐츠 작성/수정은 몰입형 화면으로 메뉴 숨김
    "/koach/coaching/contents/create",
    "/koach/coaching/contents/",
];

const KoachLayoutContainer = (props: any) => {
    const location = useLocation();
    const needStandaloneMain = STANDALONE_MAIN_PATH.some(path => location.pathname.includes(path));
    const needNoMenu = NO_MENU_PATH.some(path => location.pathname.includes(path));

    return <KoachLayoutComponent needStandaloneMain={needStandaloneMain} needNoMenu={needNoMenu} />;
};

export default KoachLayoutContainer;
